

import React, { useState } from 'react';
import tbBadgeIcon from '../../Assets/Images/rewamp/tb banner icon.svg';   // dummy — replace with actual asset
import tbBadgeAccent from '../../Assets/Images/rewamp/tb banner image.png'; // dummy — replace with actual asset

const IntroSection = ({ items = [], report_count }) => {
  const [badgeHovered, setBadgeHovered] = useState(false);

  if (!items.length) return null;

  const {
    heading,
    subheading,
    description,
    button,
    button1,
    onButtonClick,
    onSecondButtonClick,
    image
  } = items[0];

  return (
    <div className="mx-auto w-full">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap');

        .intro-heading {
          font-family: 'Inter', sans-serif;
          font-weight: 700;
          font-size: 48px;
          line-height: 1.2;
          color: var(--color-brand-primary);
          margin-bottom: 6px;
        }

        .intro-subheading {
          font-weight: 700;
          font-size: 28px;
          line-height: 1.3;
          color: var(--color-brand-green);
          margin: 0 0 16px 0;
        }

        .intro-desc {
          font-weight: 500;
          font-size: 16px;
          line-height: 1.6;
          color: var(--color-text-subheading);
          margin: 0 0 20px 0;
          max-width: 600px;
        }

        .btn-primary {
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
          background: var(--color-brand-primary);
          border: 1.5px solid var(--color-brand-primary);
          border-radius: 999px;
          min-width: 232px;
          padding: 12px 28px;
          cursor: pointer;
          transition: background 0.2s;
        }
        .btn-primary:hover { background: var(--color-brand-primary-hover); }

        .btn-outline-wrapper {
          display: inline-block;
          border-radius: 999px;
        }

        .btn-outline {
          font-weight: 600;
          font-size: 16px;
          color: var(--color-brand-primary);
          background: #ffffff;
          border: 1.5px solid var(--color-brand-primary);
          border-radius: 999px;
          min-width: 232px;
          padding: 12px 28px;
          cursor: pointer;
          transition: background 0.2s;
        }
        .btn-outline:hover { background: #EAF3FA; }

        /* BADGE */
        .reports-badge {
         width: clamp(120px, 18vw, 200px);
  height: clamp(60px, 8vw, 90px);
          background: #ffffff;
          border: 1px solid #80DAF1;
          border-radius: 8px;
          padding: 12px 16px;
          color: var(--color-brand-primary);

          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          text-align: left;

          /* 🔥 always glowing + floating */
          animation: glowPulse 3.5s ease-in-out infinite,
                     floatBadge 3.5s ease-in-out infinite;
        }

        .reports-badge:hover {
          transform: scale(1.08);
        }

        .badge-count {
          color: var(--color-brand-green);
          font-weight: 700;
          font-size: clamp(18px, 2.5vw, 28px)
        }

        .badge-label {
          font-weight: 500;
          font-size: clamp(11px, 1.2vw, 16px);
          line-height: 1.25;
          margin-top: 4px;
        }

        /* ANIMATIONS */
        @keyframes glowPulse {
          0%, 100% {
            box-shadow: 0px 4px 10px 0px #80DAF180;
          }
          50% {
            box-shadow: 0px 4px 18px 2px #80DAF1;
          }
        }

        @keyframes floatBadge {
          0%, 100% {
            transform: translateY(0px) scale(1);
          }
          50% {
            transform: translateY(-6px) scale(1.03);
          }
        }

        /* LAYOUT */
        .intro-wrapper {
          background-color: #ffffff;
          background-image: var(--section-bg-gradient);
          display: flex;
          justify-content: space-between;
          padding: 20px max(64px, calc(50% - 656px));
          overflow: hidden;
        }

        .intro-left {
          max-width: 50%;
          display: flex;
          flex-direction: column;
          margin-top: 48px;
        }

        .intro-right {
          width: 48%;
          display: flex;
          justify-content: flex-end;
        }

        .intro-btns {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
        }

        /* TB SCREENING BADGE — sized to match Smart Vitals' hb-badge */
        .tb-badge {
          display: flex;
          align-items: center;
          gap: 12px;
          margin: 0 0 24px 0;
          padding: 10px 16px;
          border-radius: 12px;
          max-width: 600px;
          background: #ffffff;
          border: 1px solid #C9EEF8;
          box-shadow: 0px 4px 10px 0px #80DAF180;
        }

        .tb-badge-icon {
          width: 52px;
          height: 52px;
          flex-shrink: 0;
          object-fit: contain;
        }

        .tb-badge-text {
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: 14px;
          line-height: 1.5;
          letter-spacing: 0%;
          flex: 1;
          min-width: 0;
          color: var(--color-brand-green);
        }

        .tb-badge-text strong {
          color: #E11D48;
          -webkit-text-fill-color: #E11D48;
          font-weight: 800;
        }

        .tb-badge-accent {
          width: 100px;
          height: 60px;
          flex-shrink: 0;
          object-fit: contain;
          align-self: center;
        }

        .intro-image-wrapper {
          position: relative;
          width: 100%;
        }

        .intro-image-container {
          width: 100%;
          height: 360px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .intro-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transform: scale(1.00) translate(30px, -10px);
        }

        .badge-overlay {
          position: absolute;
          top: 10px;
          left: -30px;
          z-index: 2;
        }

        /* TABLET */
        @media (max-width: 1024px) {
          .intro-wrapper {
            padding: 30px;
          }

          .intro-left {
            max-width: 100%;
          }

          .intro-right {
            width: 100%;
          }

          .intro-image-container {
            height: 300px;
          }

          .intro-image {
            transform: scale(1.1) translate(10px, 20px);
          }

          .badge-overlay {
            left: 0px;
            transform: scale(0.9);
          }
        }

        /* MOBILE */
@media (max-width: 768px) {
  .intro-wrapper {
    flex-direction: column;
    padding: 24px 20px;
  }

  .intro-left {
    align-items: center;
    text-align: center;
    margin-top: 0;
  }

  .intro-heading {
    font-size: 32px;
    line-height: 38px;
  }

  .intro-subheading {
    font-size: 20px;
    line-height: 28px;
  }

  .intro-desc {
    max-width: 100%;
  }

  .intro-right {
    width: 100%;
    margin-top: 20px;
  }

  .intro-image-container {
    height: 380px;
    justify-content: center;
  }

  /* A. Slightly more scale so image fills the taller container */
  .intro-image {
    transform: scale(1.15) translate(0px, 10px);
  }

  /* B. Reduced badge: smaller scale + repositioned */
  .badge-overlay {
    top: 8px;
    left: 8px;
    transform: scale(0.35);
    transform-origin: top left;
  }

  .tb-badge {
    max-width: 100%;
    padding: 12px 14px;
    gap: 10px;
    align-items: center;
  }
  .tb-badge-icon { width: 40px; height: 40px; }
  .tb-badge-text { font-size: 13px; }
  .tb-badge-accent { width: 80px; height: 48px; }
}

        /* SMALL MOBILE */
        /* SMALL MOBILE */
@media (max-width: 480px) {
  .intro-heading {
    font-size: 26px;
    line-height: 32px;
  }

  .intro-subheading {
    font-size: 16px;
  }

  .intro-image-container {
    height: 300px;
  }

  .intro-image {
    transform: scale(1.05) translate(0px, 5px);
  }

  /* B. Even smaller badge on tiny screens */
  .badge-overlay {
    transform: scale(0.55);
    transform-origin: top left;
  }

  .tb-badge {
    flex-wrap: wrap;
    padding: 10px 12px;
    gap: 8px;
    align-items: center;
  }
  .tb-badge-accent { width: 64px; height: 40px; }
  .tb-badge-icon { width: 36px; height: 36px; }
  .tb-badge-text { font-size: 12px; }
}
      `}</style>

      <div className="intro-wrapper">

        {/* LEFT */}
        <div className="intro-left">
          <h1 className="intro-heading">{heading}</h1>
          <p className="intro-subheading">{subheading}</p>
          <p className="intro-desc">{description}</p>

          {/* TB Screening Badge */}
          <div className="tb-badge">
            <img src={tbBadgeIcon} alt="TB screening icon" className="tb-badge-icon" />
            <span className="tb-badge-text">
              Now it includes early screening support for <strong>TB</strong> along with other respiratory conditions
            </span>
            <img src={tbBadgeAccent} alt="" aria-hidden="true" className="tb-badge-accent" />
          </div>

          <div className="intro-btns">
            {button && (
              <button className="btn-primary" onClick={onButtonClick}>
                {button}
              </button>
            )}

            {button1 && (
              <span className="btn-outline-wrapper">
                <button className="btn-outline" onClick={onSecondButtonClick}>
                  {button1}
                </button>
              </span>
            )}
          </div>

        </div>

        {/* RIGHT */}
        <div className="intro-right">
          <div className="intro-image-wrapper">

            {image && (
              <div className="intro-image-container">
                <img src={image} alt={heading} className="intro-image" />
              </div>
            )}

            {report_count !== undefined && (
              <div className="reports-badge badge-overlay">
                <div className="badge-count">{report_count}</div>
                <div className="badge-label">Reports Generated</div>
              </div>
            )}

          </div>
        </div>

      </div>
    </div>
  );
};

export default IntroSection;